import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { Flex, Label, Pane, Text } from '@leverege/ui-elements';
import { Interface } from '@leverege/api-redux';
import { DataSources } from '@leverege/ui-attributes';
import { Blueprint } from '@leverege/molten/imagine';
import { GlobalState } from '@leverege/ui-redux';
import DeviceInput from '../../pairing/DeviceInput';
import DeviceSearch from '../../pairing/DeviceSearch';
import Detail from './Detail';
import Scan from '../../pairing/Scan';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class SelectLocator extends React.Component {
  constructor(props) {
    super(props);
    const locatorBlueprint = Blueprint.getByType('locator');
    this.locatorDeviceNetwork = locatorBlueprint.getTagStartingWith('network:', true);
  }
  onClickDeviceInput = () => {
    const {
      onChange,
      formState: {
        isScanning
      }
    } = this.props;
    onChange({
      data: 'isScanning',
      value: !isScanning
    });
  };
  onFocus = () => {
    const {
      onChange,
      formState: {
        isSearching
      }
    } = this.props;
    onChange({
      data: 'isSearching',
      value: !isSearching
    });
  };
  renderSearch() {
    const {
      location,
      relationship,
      onClose,
      onSearchChange,
      actions
    } = this.props;
    const path = relationship?.path;
    return /*#__PURE__*/_jsx(DeviceSearch, {
      ...this.props,
      iFace: path === 'sale' ? Interface.create(actions.systemId, 'locator') : undefined,
      onChange: onSearchChange,
      onClick: onClose,
      onClose: this.onFocus,
      networkId: this.locatorDeviceNetwork,
      additionalFilters: path === 'sale' ? [] : [{
        type: 'equals',
        value: location.id,
        field: 'data/location/id'
      }]
    });
  }
  renderScan() {
    const {
      location,
      relationship,
      onScanChange,
      actions
    } = this.props;
    const path = relationship?.path;
    return /*#__PURE__*/_jsx(Scan, {
      ...this.props,
      networkId: this.locatorDeviceNetwork,
      eventData: "locatorId",
      onClick: this.onClickDeviceInput,
      iFace: path === 'sale' ? Interface.create(actions.systemId, 'locator') : undefined,
      onChange: onScanChange,
      additionalFilters: path === 'sale' ? [] : [{
        type: 'equals',
        value: location.id,
        field: 'data/location/id'
      }]
    });
  }
  render() {
    const {
      formState
    } = this.props;
    const {
      locatorId,
      isSearching,
      isScanning,
      locatorError,
      selectedLocator
    } = formState;
    if (isSearching) {
      return this.renderSearch();
    }
    if (isScanning) {
      return this.renderScan();
    }
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "Select Replacement Locator"
      }), /*#__PURE__*/_jsx(Text, {
        children: "Scan the QR code or search by Locator ID to select the Locator that will be used as the replacement."
      }), /*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: "Replacement Locator ID"
      }), /*#__PURE__*/_jsx(DeviceInput, {
        eventData: "locatorId",
        value: locatorId,
        onClick: this.onClickDeviceInput,
        onFocus: this.onFocus,
        hint: "Search Locator ID",
        error: locatorError
      }), /*#__PURE__*/_jsx(ErrorContent, {
        error: locatorError,
        locator: selectedLocator,
        ...this.props
      }), !locatorError && selectedLocator && /*#__PURE__*/_jsx(Flex, {
        variant: "colM",
        children: /*#__PURE__*/_jsx(LocatorInfoCard, {
          locator: selectedLocator,
          ...this.props
        })
      })]
    });
  }
}
function ErrorContent({
  error,
  locator,
  ...rest
}) {
  switch (error) {
    case 'lowBattery':
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsxs(Text, {
          variant: "salesFlowError",
          style: {
            alignItems: 'flex-start'
          },
          children: [/*#__PURE__*/_jsx("b", {
            children: "Warning:"
          }), " Locator battery is below the 70% threshold recommended for replacement. Please select another locator."]
        }), /*#__PURE__*/_jsx(LocatorInfoCard, {
          locator: locator,
          ...rest
        })]
      });
    case 'offline':
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsxs(Text, {
          variant: "salesFlowError",
          style: {
            alignItems: 'flex-start'
          },
          children: [/*#__PURE__*/_jsx("b", {
            children: "Warning:"
          }), " This locator has been offline for over 3 hours. Please select a different locator."]
        }), /*#__PURE__*/_jsx(LocatorInfoCard, {
          locator: locator,
          ...rest
        })]
      });
    case 'unactivated':
      return /*#__PURE__*/_jsx(LocatorUnacticatedError, {});
    default:
      return null;
  }
}
function LocatorInfoCard({
  locator,
  ...rest
}) {
  const [company, setCompany] = useState(locator.data.company?.id);
  const [location, setLocation] = useState(locator.data.location?.id);
  const systemId = window.Molten.getConfig('api/systemId');
  useEffect(() => {
    const companyObj = {
      id: locator.data.company?.id,
      type: 'company',
      ref: `${systemId}/company`
    };
    const companyActions = DataSources.getActions(companyObj);
    GlobalState.dispatch(companyActions.get()).then(res => {
      setCompany(res.data?.name);
    });
    const {
      locationActions
    } = rest;
    const locationGroupActions = locationActions.parent();
    GlobalState.dispatch(locationGroupActions.item(locator.data.location?.id).get()).then(res => {
      setLocation(res.data?.name);
    });
  }, [locator.data.company?.id, locator.data.location?.id]);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    children: /*#__PURE__*/_jsx(Pane, {
      layout: "flex:rowXXL",
      variant: "dataCard",
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colM",
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/_jsx(Detail, {
          label: "Company",
          value: company || 'None'
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Location",
          value: location || 'None'
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Battery Level",
          value: locator.data.batteryLevel != null ? `${locator.data.batteryLevel}%` : 'Unknown'
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Last Heartbeat",
          value: locator.data.lastHeartbeat ? format(locator.data.lastHeartbeat, 'MM/dd h:mmaaa') : 'Unknown'
        })]
      })
    })
  });
}
function LocatorUnacticatedError() {
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    children: /*#__PURE__*/_jsx(Pane, {
      layout: "flex:rowXXL",
      variant: "dataCard",
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colL",
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodyBold",
          children: "Locator is Not Activated"
        }), /*#__PURE__*/_jsx(Text, {
          children: "You must activate a locator to pair it to a vehicle."
        }), /*#__PURE__*/_jsx(Text, {
          children: "1. Remove the \"Remove to Activate\" sticker."
        }), /*#__PURE__*/_jsx(Text, {
          children: "2. Flip the Locator over. When the LED turns green and the Locator buzzes, it\u2019s activated."
        }), /*#__PURE__*/_jsx(Text, {
          variant: "billingCardLink",
          children: /*#__PURE__*/_jsx("a", {
            href: "https://help.recovr.biz/en/articles/5075532-locator-activation",
            target: "_blank",
            rel: "noreferrer",
            children: "Read the Documentation"
          })
        })]
      })
    })
  });
}